import React from "react"
import ReactApexChart from "react-apexcharts"

import MetricHint from "./MetricHint"
import { cardStyle, mutedStyle, GrowthBadge } from "./common"

/**
 * Карточка метрики: значение, спарклайн за период и ДВА сравнения — с прошлым
 * месяцем и с тем же месяцем прошлого года. Сезонность в общепите сильная,
 * и «месяц к месяцу» без «года к году» вводит в заблуждение.
 */
function KpiCard({ title, hintKey, value, sublabel, growth, yoy, sparkline, accent = "#4c8df0" }) {
	const hasSpark = Array.isArray(sparkline) && sparkline.filter((item) => Number(item) > 0).length > 1

	const sparkOptions = {
		chart: { type: "area", sparkline: { enabled: true }, fontFamily: "inherit" },
		colors: [accent],
		stroke: { curve: "smooth", width: 2 },
		fill: { type: "gradient", gradient: { opacityFrom: 0.3, opacityTo: 0 } },
		tooltip: { enabled: false },
	}

	return (
		<div className="card h-100 mb-0" style={cardStyle}>
			<div className="card-body py-3 px-3">
				<div className="d-flex align-items-center gap-1" style={mutedStyle}>
					<span>{title}</span>
					<MetricHint hintKey={hintKey} />
				</div>

				<h3
					className="mb-0 mt-2"
					style={{ fontSize: "22px", fontWeight: 800, color: "var(--dark-text-strong, #111827)", letterSpacing: "-0.5px" }}
				>
					{value}
				</h3>

				{sublabel && <div style={{ ...mutedStyle, marginTop: "2px" }}>{sublabel}</div>}

				<div className="d-flex flex-wrap align-items-center gap-2 mt-2">
					<GrowthBadge value={growth} label="м/м" />
					<GrowthBadge value={yoy} label="г/г" />
				</div>

				{hasSpark && (
					<div style={{ marginTop: "6px", marginBottom: "-10px" }}>
						<ReactApexChart
							options={sparkOptions}
							series={[{ name: title, data: sparkline }]}
							type="area"
							height={40}
						/>
					</div>
				)}
			</div>
		</div>
	)
}

export default KpiCard
